import React, { memo } from "react";
import { useLocation } from "react-router-dom";
import { strings } from "investira.sdk";
import {
  Stack,
  Typography,
  CircularProgress,
  Button,
  Icon,
} from "investira.react.components";
import { PaginationTemplate } from "../../components/templates";
import { BuscaAtivo, SearchAtivos } from "../../components/organisms";
import services from "../../services";
import AtivosItem from "./AtivosItem";
import AtivosFilter from "./AtivosFilter";

const Ativos = memo((props) => {
  const location = useLocation();
  const search = strings.querystringToObject(location.search);

  function sort(pSearch) {
    let xValues = "relevancia DESC, mercado ASC";

    if ("pesquisa" in pSearch) {
      xValues = "relevancia DESC, __mr__ DESC, mercado ASC";
    }

    return xValues;
  }

  return (
    <PaginationTemplate
      id="ativos"
      title={"Ativos"}
      description="Listas de ativos do mercado financeiro! Fundos, títulos públicos, títulos bancários, ações, fundos imobiliários, BDRs, ETFs, tesouro direto e outros mais."
      dataRead={services.ativosbase.list}
      dataReadParams={{
        cancelado: "null",
        sort: sort(search),
      }}
      searchComponent={SearchAtivos}
      filterComponent={AtivosFilter}
      listItem={AtivosItem}
      listItemKey="ifeed_ativo_id"
      match={"ativos/busca/*"}
      maxWidth="xl"
    />
  );
});

PaginationTemplate.displayName = "PaginationTemplate";

export default Ativos;
